export default __webpack_public_path__ + "bfb7e567634a7ae8771fdd9dd8df086c.png";